<template>
  <div class="historical-agreement-details-box">
    <div class="details-title"><h2>{{title}}</h2></div>
    <div class="details-content" v-html="content"></div>
  </div>
</template>
<script>
import api from "@/api";
import {isEmpty, isMobile} from '@/utilities/tools'

export default {
  name: "HistoricalAgreementList",
  data () {
    return {
      title: "",
      content: ''
    }
  },
  created () {
    const query = this.$router.currentRoute.query;
    if(isMobile()) {
      window.location.href = `${process.env.VUE_APP_MOBILE_URL}/Rccl.UserCenter/HistoricalAgreementDetails?${query}`;
      return;
    }
    let userAgreementType = "";
    let effectiveDateStr = "";
    let ver = "";
    let id = null;
    if (query && !isEmpty(query.type)) {
      if (isNaN(Number(query.type))) {
        return;
      } else {
        userAgreementType = Number(query.type);
      }
    }
    if (query && !isEmpty(query.dateStr)) {
      effectiveDateStr = query.dateStr
    }
    if (query && !isEmpty(query.ver)) {
      if (isNaN(Number(query.ver))) {
        return;
      } else {
        ver = Number(query.ver);
      }
    }
    if (query && !isEmpty(query.id)) {
      if (isNaN(Number(query.id))) {
        return;
      } else {
        id = Number(query.id);
      }
    }
    this.initPage(userAgreementType, effectiveDateStr, ver, id)
  },
  methods: {
    async initPage(userAgreementType, effectiveDateStr, ver, id) {
      const { success, data, errMsg } = await api.user.getAgreementByParams({
        userAgreementType: userAgreementType,
        effectiveDateStr: effectiveDateStr,
        ver: ver,
        id: id
      })
      if (success && data) {
        this.title = data.title;
        this.content = data.content;
      } else {
        console.log(errMsg)
      }
    }
  }
}
</script>
<style lang="less">
.historical-agreement-details-box {
  width: 90%;
  margin: 0 auto;
  padding: 0 0 40px;
  & .details-title {
    text-align: center;
    width: 100%;
    & > h2 {
      margin-top: 25px;
      margin-bottom: 15px;
      font-size: 32px;
      font-weight: normal;
      color: #478cc7;
    }
  }
  & .details-content {
    margin-top: 20px;
    p {
      margin: 10px 0;
    }
    .table {
      width: 100%;
      overflow-x: auto;
      border-collapse: collapse;
      border: 2px solid #808080;
    }
    .table .th {
      padding: 8px;
      border: 2px solid #808080;
    }
    .table .td {
      vertical-align: top;
      padding: 8px;
      border: 2px solid #808080;
    }
    .table .th p,
    .table .td p {
      margin: 0;
    }
    .tableBox .table {
      border-collapse: collapse;
    }
  }
}
</style>